// Hook to fetch the reports config data

/*  Shared  */
import { Notify } from 'application/Shared/Helpers';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  React  */
import { useEffect, useState } from 'react';

export const useFetchReportConfig = ({ clientId, t }) => {
    const [reportConfiguration, setReportConfiguration] = useState([]);
    const [loading, setLoading] = useState(true);
    // calling refetchData will force a rerender on the hook
    const [shouldRefetchData, setShouldRefetchContract] = useState({});

    const refetchData = () => setShouldRefetchContract({});

    useEffect(() => {
        const { CancelToken } = axios;
        const source = CancelToken.source();

        const fetchData = async () => {
            setLoading(true);
            try {
                const params = {};
                if (clientId) {
                    params.platformTenantId = clientId;
                    params.includeClients = true;
                }
                const response = await axios.get('/reports/config', {
                    cancelToken: source.token,
                    params
                });
                const { data } = response.data;
                if (data) {
                    setReportConfiguration(data);
                }
            } catch (error) {
                Notify.error(
                    t('Reports.Contracts.errorLoadingReportConfiguration')
                );
                debug.e('Unable to load report configuration.', error);
            }
            setLoading(false);
        };

        fetchData();

        return () => {
            // Cancel the request when the component unmounts
            source.cancel();
        };
    }, [clientId, shouldRefetchData, t]);

    return {
        loading,
        // returning the refetchData function so we can call it as needed.
        refetchData,
        reportConfiguration
    };
};
